import { render, staticRenderFns } from "./EditStorehouse.vue?vue&type=template&id=0a5e0cce"
import script from "./EditStorehouse.vue?vue&type=script&lang=js"
export * from "./EditStorehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports